import { IUser } from '../../modules/Auth/models/user.model';
import { isB2BUser } from '../utils/user';
import { Permissions } from './permissions';

export const hasExactPermission = (
  userPermissions: Permissions[],
  requiredPermission: Permissions
): boolean => {
  if (_checkIfHasAll(userPermissions)) {
    return true;
  }

  return userPermissions.includes(requiredPermission);
};

export const hasAnyPermission = (
  userPermissions: Permissions[],
  requiredPermissions: Permissions[]
): boolean => {
  if (_checkIfHasAll(userPermissions)) {
    return true;
  }

  return requiredPermissions.some((perm) => userPermissions.includes(perm));
};

export const hasAllPermissions = (
  userPermissions: Permissions[],
  requiredPermissions: Permissions[]
): boolean => {
  if (_checkIfHasAll(userPermissions)) {
    return true;
  }

  return requiredPermissions.every((perm) => userPermissions.includes(perm));
};

export const hasAllPermissionsWithPrefix = (
  userPermissions: Permissions[],
  prefix: string
): boolean => {
  if (_checkIfHasAll(userPermissions)) {
    return true;
  }

  const allPermissionsWithPrefix = Object.values(Permissions).filter((perm) =>
    perm.toLowerCase().startsWith(prefix.toLowerCase())
  );

  return allPermissionsWithPrefix.every((requiredPerm) =>
    userPermissions.includes(requiredPerm as Permissions)
  );
};

export const hasAnyPermissionWithPrefix = (
  userPermissions: Permissions[],
  prefix: string
): boolean => {
  if (_checkIfHasAll(userPermissions)) {
    return true;
  }

  const allPermissionsWithPrefix = Object.values(Permissions).filter((perm) =>
    perm.toLowerCase().startsWith(prefix.toLowerCase())
  );

  return userPermissions.some((userPerm) =>
    allPermissionsWithPrefix.includes(userPerm)
  );
};

export const getUserPermissions = (user?: IUser | null): Permissions[] => {
  if (!user) return [];
  if (isB2BUser(user, 'statera')) {
    return [
      Permissions.FAVORITOS,

      Permissions.MINHA_AREA,
      Permissions.MINHA_AREA_ULTIMOS_CONTEUDOS_VISTOS,
      Permissions.MINHA_AREA_FAVORITOS,
      Permissions.MINHA_AREA_DOSSIES_DE_INCIDENCIA,
      Permissions.MINHA_AREA_AULA_DESTAQUE,
      Permissions.MINHA_AREA_MINHAS_METRICAS,

      Permissions.TRILHAS_DE_ENSINO_REGIONAIS,

      Permissions.DISCIPLINAS_INTERDISCIPLINAR,
      Permissions.DISCIPLINAS_BIOLOGIA,
      Permissions.DISCIPLINAS_FISICA,
      Permissions.DISCIPLINAS_QUIMICA,
      Permissions.DISCIPLINAS_MATEMATICA,
      Permissions.DISCIPLINAS_HISTORIA,
      Permissions.DISCIPLINAS_GEOGRAFIA,
      Permissions.DISCIPLINAS_ATUALIDADES,
      Permissions.DISCIPLINAS_FILOSOFIA,
      Permissions.DISCIPLINAS_SOCIOLOGIA,
      Permissions.DISCIPLINAS_PORTUGUES,
      Permissions.DISCIPLINAS_LITERATURA,
      Permissions.DISCIPLINAS_REDACAO,
      Permissions.DISCIPLINAS_INGLES,
      Permissions.DISCIPLINAS_ESPANHOL,

      Permissions.SIMULADOS_SIMULADOR,
      Permissions.SIMULADOS_SIMULADOS_ENEM,
    ];
  }

  return [Permissions.ALL];
};

const _checkIfHasAll = (userPermissions: Permissions[]): boolean => {
  return userPermissions.some((perm) => perm === Permissions.ALL);
};
